/**
 *   This is a autogenerated file that is created by parsig op-code files
 *   To regenerate it use
 *
 *   ts-node scripts/scan_opcodes.ts
 **/

export class ContractOpcodes {
  static ACCOUNTV3_RESET_GAS: number = 0x42a0fb43; // 1117846339
  static ACCOUNTV3_ADD_LIQUIDITY: number = 0x3ebe5431; // 1052660785
  static ACCOUNTV3_CB_ADD_LIQUIDITY: number = 0x56dfeb8a; // 1457515402
  static ACCOUNTV3_GETTER_LP_ACCOUNT_DATA: number = 0x1d439ae0; // 490969824
  static ACCOUNTV3_DIRECT_ADD_LIQUIDITY: number = 0x4cf82803; // 1291331587
  static ACCOUNTV3_REFUND_ME: number = 0xbf3f447; // 200537159
  static ACCOUNTV3_CB_REFUND_ME: number = 0x89446a42; // 2302962242
  static JETTON_PROVIDE_WALLET_ADDRESS: number = 0x2c76b973; // 745978227
  static JETTON_TAKE_WALLET_ADDRESS: number = 0xd1735400; // 3513996288
  static JETTON_TRANSFER: number = 0xf8a7ea5; // 260734629
  static JETTON_TRANSFER_NOTIFICATION: number = 0x7362d09c; // 1935855772
  static JETTON_INTERNAL_TRANSFER: number = 0x178d4519; // 395134233
  static JETTON_EXCESSES: number = 0xd53276db; // 3576854235
  static JETTON_BURN: number = 0x595f07bc; // 1499400124
  static JETTON_BURN_NOTIFICATION: number = 0x7bdd97de; // 2078119902
  static JETTON_MINT: number = 0x15; // 21
  static NFT_TRANSFER: number = 0x5fcc3d14; // 1607220500
  static NFT_OWNERSHIP_ASSIGNED: number = 0x5138d91; // 85167505
  static NFT_EXCESSES: number = 0xd53276db; // 3576854235
  static NFT_GET_STATIC_DATA: number = 0x2fcb26a2; // 801842850
  static NFT_REPORT_STATIC_DATA: number = 0x8b771735; // 2339837749
  static NFT_GET_ROYALTY_PARAMS: number = 0x693d3950; // 1765620048
  static NFT_REPORT_ROYALTY_PARAMS: number = 0xa8cb00ad; // 2831876269
  static NFT_EDIT_CONTENT: number = 0x1a0b9d51; // 436968785
  static NFT_TRANSFER_EDITORSHIP: number = 0x1c04412a; // 470040874
  static NFT_EDITORSHIP_ASSIGNED: number = 0x511a4463; // 1360675939
  static POOL_FACTORY_CHANGE_PARAMS: number = 0xaa0db3d7; // 2853024727
  static POOL_FACTORY_CREATE_POOL: number = 0x9e9a8f7f; // 2660929407
  static POOL_FACTORY_RESET_GAS: number = 0x42a0fb43; // 1117846339
  static POOL_FACTORY_ORDER_INIT: number = 0x8b85de63; // 2340806243
  static POOL_FACTORY_EXECUTE: number = 0xd4b33b0a; // 3568515850
  static POOLV3_INIT: number = 0x441c39ed; // 1142700525
  static POOLV3_LOCK: number = 0x5e74697; // 99042967
  static POOLV3_UNLOCK: number = 0x3205adbd; // 839232957
  static POOLV3_SET_FEE: number = 0x6bdcbeb8; // 1809628856
  static POOLV3_SWAP: number = 0xa7fb58f8; // 2818267384
  static POOLV3_FUND_ACCOUNT: number = 0x4468de77; // 1147723383
  static POOLV3_MINT: number = 0x81702ef8; // 2171612920
  static POOLV3_START_BURN: number = 0x530b5f2c; // 1393254188
  static POOLV3_BURN: number = 0xd73ac09d; // 3610951837
  static POOLV3_COLLECT_PROTOCOL: number = 0xd3f8a538; // 3556287800
  static POOLV3_RESET_GAS: number = 0x42a0fb43; // 1117846339
  static POOLV3_MINT_M: number = 0xdbb7bb55; // 3686251349
  static POOLV3_BURN_M: number = 0xe639646c; // 3862520940
  static POOLV3_SWAP_M: number = 0xdb913023; // 3683725347
  static POOLV3_FILL_TICK_M: number = 0x80139ad6; // 2148768470
  static POSITIONNFTV3_NFT_TRANSFER: number = 0x5fcc3d14; // 1607220500
  static POSITIONNFTV3_OWNERSHIP_ASSIGNED: number = 0x5138d91; // 85167505
  static POSITIONNFTV3_EXCESSES: number = 0xd53276db; // 3576854235
  static POSITIONNFTV3_GET_STATIC_DATA: number = 0x2fcb26a2; // 801842850
  static POSITIONNFTV3_REPORT_STATIC_DATA: number = 0x8b771735; // 2339837749
  static POSITIONNFTV3_GET_ROYALTY_PARAMS: number = 0x693d3950; // 1765620048
  static POSITIONNFTV3_REPORT_ROYALTY_PARAMS: number = 0xa8cb00ad; // 2831876269
  static POSITIONNFTV3_POSITION_INIT: number = 0xd5ecca2a; // 3589065258
  static POSITIONNFTV3_POSITION_BURN: number = 0x46ca335a; // 1187656538
  static POSITIONNFTV3_FEE_COLLECTED: number = 0x5ee6039f; // 1592132511
  static POSITIONNFTV3_OWNERSHIP_ASSIGNED_NOTIFY: number = 0xf58760ef; // 4119290095
  static POSITIONNFTV3_EDIT_CONTENT: number = 0x1a0b9d51; // 436968785
  static POSITIONNFTV3_TRANSFER_EDITORSHIP: number = 0x1c04412a; // 470040874
  static POSITIONNFTV3_EDITORSHIP_ASSIGNED: number = 0x511a4463; // 1360675939
  static ROUTERTV3_ADD_POOL: number = 0x5bcb5a84; // 1540053636
  static ROUTERTV3_CHANGE_ADMIN: number = 0xb3bc094; // 188465300
  static ROUTERV3_PAY_TO: number = 0xa1daa96d; // 2715461997
  static ROUTERV3_CREATE_POOL: number = 0x2e3034ef; // 774911215
  static ROUTERV3_RESET_GAS: number = 0x42a0fb43; // 1117846339
  static ROUTERV3_CHANGE_ADMIN_START: number = 0xd4deb03b; // 3571363899
  static ROUTERV3_CHANGE_ADMIN_COMMIT: number = 0x98bac405; // 2562376709
  static ROUTERV3_CHANGE_PARAMS: number = 0x87ffe363; // 2281694051
  static SINKV3_SET: number = 0xe61425dc; // 3860080092
  static SINKV3_ADD: number = 0xfd1a73e7; // 4246369255
  static SINKV3_TEST_GAS: number = 0x7337ed7; // 120815319
  static SINKV3_DUMMY: number = 0xfffffeee; // 4294967022
  static TONPROXY_MINTER_PROVIDE_WALLET_ADDRESS: number = 0x2c76b973; // 745978227
  static TONPROXY_MINTER_TAKE_WALLET_ADDRESS: number = 0xd1735400; // 3513996288
  static TONPROXY_MINTER_DEPLOY_WALLET: number = 0xcf5f4313; // 3479126803
  static TONPROXY_MINTER_INTERNAL_DEPLOY: number = 0x6540cf85; // 1698746245
  static TONPROXY_MINTER_TON_TRANSFER: number = 0x1f3835d; // 32736093
  static TONPROXY_MINTER_RESET_GAS: number = 0x29d22935; // 701638965
  static TONPROXY_MINTER_TON_REFUND: number = 0xae25d79e; // 2921715614
}

export const OpcodesLookup: { [x: number]: string } = {
  0x15: 'JETTON_MINT',
  0x1f3835d: 'TONPROXY_MINTER_TON_TRANSFER',
  0x5138d91: 'NFT_OWNERSHIP_ASSIGNED,POSITIONNFTV3_OWNERSHIP_ASSIGNED',
  0x5e74697: 'POOLV3_LOCK',
  0x7337ed7: 'SINKV3_TEST_GAS',
  0xb3bc094: 'ROUTERTV3_CHANGE_ADMIN',
  0xbf3f447: 'ACCOUNTV3_REFUND_ME',
  0xf8a7ea5: 'JETTON_TRANSFER',
  0x178d4519: 'JETTON_INTERNAL_TRANSFER',
  0x1a0b9d51: 'NFT_EDIT_CONTENT,POSITIONNFTV3_EDIT_CONTENT',
  0x1c04412a: 'NFT_TRANSFER_EDITORSHIP,POSITIONNFTV3_TRANSFER_EDITORSHIP',
  0x1d439ae0: 'ACCOUNTV3_GETTER_LP_ACCOUNT_DATA',
  0x29d22935: 'TONPROXY_MINTER_RESET_GAS',
  0x2c76b973: 'JETTON_PROVIDE_WALLET_ADDRESS,TONPROXY_MINTER_PROVIDE_WALLET_ADDRESS',
  0x2e3034ef: 'ROUTERV3_CREATE_POOL',
  0x2fcb26a2: 'NFT_GET_STATIC_DATA,POSITIONNFTV3_GET_STATIC_DATA',
  0x3205adbd: 'POOLV3_UNLOCK',
  0x3ebe5431: 'ACCOUNTV3_ADD_LIQUIDITY',
  0x42a0fb43: 'ACCOUNTV3_RESET_GAS,POOL_FACTORY_RESET_GAS,POOLV3_RESET_GAS,ROUTERV3_RESET_GAS',
  0x441c39ed: 'POOLV3_INIT',
  0x4468de77: 'POOLV3_FUND_ACCOUNT',
  0x46ca335a: 'POSITIONNFTV3_POSITION_BURN',
  0x4cf82803: 'ACCOUNTV3_DIRECT_ADD_LIQUIDITY',
  0x511a4463: 'NFT_EDITORSHIP_ASSIGNED,POSITIONNFTV3_EDITORSHIP_ASSIGNED',
  0x530b5f2c: 'POOLV3_START_BURN',
  0x56dfeb8a: 'ACCOUNTV3_CB_ADD_LIQUIDITY',
  0x595f07bc: 'JETTON_BURN',
  0x5bcb5a84: 'ROUTERTV3_ADD_POOL',
  0x5ee6039f: 'POSITIONNFTV3_FEE_COLLECTED',
  0x5fcc3d14: 'NFT_TRANSFER,POSITIONNFTV3_NFT_TRANSFER',
  0x6540cf85: 'TONPROXY_MINTER_INTERNAL_DEPLOY',
  0x693d3950: 'NFT_GET_ROYALTY_PARAMS,POSITIONNFTV3_GET_ROYALTY_PARAMS',
  0x6bdcbeb8: 'POOLV3_SET_FEE',
  0x7362d09c: 'JETTON_TRANSFER_NOTIFICATION',
  0x7bdd97de: 'JETTON_BURN_NOTIFICATION',
  0x80139ad6: 'POOLV3_FILL_TICK_M',
  0x81702ef8: 'POOLV3_MINT',
  0x87ffe363: 'ROUTERV3_CHANGE_PARAMS',
  0x89446a42: 'ACCOUNTV3_CB_REFUND_ME',
  0x8b771735: 'NFT_REPORT_STATIC_DATA,POSITIONNFTV3_REPORT_STATIC_DATA',
  0x8b85de63: 'POOL_FACTORY_ORDER_INIT',
  0x98bac405: 'ROUTERV3_CHANGE_ADMIN_COMMIT',
  0x9e9a8f7f: 'POOL_FACTORY_CREATE_POOL',
  0xa1daa96d: 'ROUTERV3_PAY_TO',
  0xa7fb58f8: 'POOLV3_SWAP',
  0xa8cb00ad: 'NFT_REPORT_ROYALTY_PARAMS,POSITIONNFTV3_REPORT_ROYALTY_PARAMS',
  0xaa0db3d7: 'POOL_FACTORY_CHANGE_PARAMS',
  0xae25d79e: 'TONPROXY_MINTER_TON_REFUND',
  0xcf5f4313: 'TONPROXY_MINTER_DEPLOY_WALLET',
  0xd1735400: 'JETTON_TAKE_WALLET_ADDRESS,TONPROXY_MINTER_TAKE_WALLET_ADDRESS',
  0xd3f8a538: 'POOLV3_COLLECT_PROTOCOL',
  0xd4b33b0a: 'POOL_FACTORY_EXECUTE',
  0xd4deb03b: 'ROUTERV3_CHANGE_ADMIN_START',
  0xd53276db: 'JETTON_EXCESSES,NFT_EXCESSES,POSITIONNFTV3_EXCESSES',
  0xd5ecca2a: 'POSITIONNFTV3_POSITION_INIT',
  0xd73ac09d: 'POOLV3_BURN',
  0xdb913023: 'POOLV3_SWAP_M',
  0xdbb7bb55: 'POOLV3_MINT_M',
  0xe61425dc: 'SINKV3_SET',
  0xe639646c: 'POOLV3_BURN_M',
  0xf58760ef: 'POSITIONNFTV3_OWNERSHIP_ASSIGNED_NOTIFY',
  0xfd1a73e7: 'SINKV3_ADD',
  0xfffffeee: 'SINKV3_DUMMY',
};
export class ContractErrors {
  static COMMON_WRONG_OP: number = 65535; // 0xffff
  static COMMON_WRONG_WORKCHAIN: number = 333; // 0x14d
  static JETTON_INVALID_OP: number = 709; // 0x2c5
  static JETTON_NOT_ADMIN: number = 73; // 0x49
  static JETTON_UNOUTHORIZED_BURN: number = 74; // 0x4a
  static JETTON_DISCOVERY_FEE_NOT_MATCHED: number = 75; // 0x4b
  static JETTON_NOT_OWNER: number = 705; // 0x2c1
  static JETTON_NOT_ENOUGH_TON: number = 709; // 0x2c5
  static JETTON_NOT_ENOUGH_GAS: number = 707; // 0x2c3
  static JETTON_NOT_VALID_WALLET: number = 707; // 0x2c3
  static JETTON_BALANCE_ERROR: number = 706; // 0x2c2
  static NFT_NOT_OWNER: number = 401; // 0x191
  static POOL_FACTORY_INVALID_AMOUNT: number = 110; // 0x6e
  static POOL_FACTORY_INVALID_CALLER: number = 111; // 0x6f
  static POOL_FACTORY_POOL_ILLEGAL_PARAMS: number = 112; // 0x70
  static POOL_FACTORY_INSUFFICIENT_GAS: number = 113; // 0x71
  static POOLV3_NO_LIQUIDITY: number = 80; // 0x50
  static POOLV3_ZERO_OUTPUT: number = 81; // 0x51
  static POOLV3_INVALID_CALLER: number = 82; // 0x52
  static POOLV3_INSUFFICIENT_GAS: number = 83; // 0x53
  static POOLV3_INVALID_TOKEN: number = 86; // 0x56
  static POOLV3_LOW_AMOUNT: number = 87; // 0x57
  static POOLV3_MATH_ERROR: number = 90; // 0x5a
  static POOLV3_TICK_IMPOSSIBLE_LOW: number = 91; // 0x5b
  static POOLV3_TICK_IMPOSSIBLE_HIGH: number = 92; // 0x5c
  static POOLV3_PRICE_IMPOSSIBLE_LOW: number = 93; // 0x5d
  static POOLV3_PRICE_IMPOSSIBLE_HIGH: number = 94; // 0x5e
  static POOLV3_PRICE_LIMIT_WRONG: number = 95; // 0x5f
  static POOLV3_LOWER_THEN_MIN_OUT: number = 96; // 0x60
  static POOLV3_INVALID_RECIPIENT: number = 100; // 0x64
  static POOLV3_POOL_UNDEPLOYED: number = 101; // 0x65
  static POOLV3_POOL_INACTIVE: number = 102; // 0x66
  static POOLV3_FORGED_NFT: number = 103; // 0x67
  static POOLV3_BURN_PARAMETERS_WRONG: number = 104; // 0x68
  static POOLV3_RESERVES_PROTECTION_ERROR_SIGN: number = 105; // 0x69
  static POOLV3_RESERVES_PROTECTION_ERROR_DRAIN: number = 106; // 0x6a
  static POOLV3_POOL_MALFORMED: number = 107; // 0x6b
  static POOLV3_RESULT_SWAP_OK: number = 200; // 0xc8
  static POOLV3_RESULT_BURN_OK: number = 201; // 0xc9
  static POOLV3_RESULT_MINT_OK: number = 202; // 0xca
  static POOLV3_RESULT_COLLECT_OK: number = 203; // 0xcb
  static POOLV3_RESULT_SWAP_OUTPUT_TOO_SMALL: number = 230; // 0xe6
  static POOLV3_RESULT_TICK_IMPOSSIBLE_LOW: number = 220; // 0xdc
  static POOLV3_RESULT_TICK_IMPOSSIBLE_HIGH: number = 221; // 0xdd
  static POOLV3_RESULT_WRONG_TICK_SPACING: number = 222; // 0xde
  static POOLV3_RESULT_TOO_MANY_TICKS: number = 223; // 0xdf
  static POOLV3_RESULT_TOO_MUCH_LIQUIDITY: number = 224; // 0xe0
  static POOLV3_RESULT_NOT_ENOUGH_COINS: number = 225; // 0xe1
  static POOLV3_RESULT_NO_LIQUIDITY: number = 226; // 0xe2
  static POSITIONNFTV3_INVALID_CALLER: number = 82; // 0x52
  static POSITIONNFTV3_INIT_NOT_BY_COLLECTION: number = 405; // 0x195
  static POSITIONNFTV3_NOT_AN_OWNER: number = 401; // 0x191
  static POSITIONNFTV3_ALREADY_BURNED: number = 408; // 0x198
  static POSITIONNFTV3_WRONG_BURN_TICKS: number = 409; // 0x199
  static POSITIONNFTV3_MESSAGE_TOO_LONG: number = 708; // 0x2c4
  static ROUTERV3_INVALID_AMOUNT: number = 110; // 0x6e
  static ROUTERV3_INVALID_CALLER: number = 111; // 0x6f
  static ROUTERV3_POOL_ILLEGAL_PARAMS: number = 112; // 0x70
  static ROUTERV3_INSUFFICIENT_GAS: number = 113; // 0x71
  static ROUTERV3_TIMELOCK_NOT_RESPECTED: number = 114; // 0x72
}

export const ErrorsLookup = {
  73: 'JETTON_NOT_ADMIN',
  74: 'JETTON_UNOUTHORIZED_BURN',
  75: 'JETTON_DISCOVERY_FEE_NOT_MATCHED',
  80: 'POOLV3_NO_LIQUIDITY',
  81: 'POOLV3_ZERO_OUTPUT',
  82: 'POOLV3_INVALID_CALLER,POSITIONNFTV3_INVALID_CALLER',
  83: 'POOLV3_INSUFFICIENT_GAS',
  86: 'POOLV3_INVALID_TOKEN',
  87: 'POOLV3_LOW_AMOUNT',
  90: 'POOLV3_MATH_ERROR',
  91: 'POOLV3_TICK_IMPOSSIBLE_LOW',
  92: 'POOLV3_TICK_IMPOSSIBLE_HIGH',
  93: 'POOLV3_PRICE_IMPOSSIBLE_LOW',
  94: 'POOLV3_PRICE_IMPOSSIBLE_HIGH',
  95: 'POOLV3_PRICE_LIMIT_WRONG',
  96: 'POOLV3_LOWER_THEN_MIN_OUT',
  100: 'POOLV3_INVALID_RECIPIENT',
  101: 'POOLV3_POOL_UNDEPLOYED',
  102: 'POOLV3_POOL_INACTIVE',
  103: 'POOLV3_FORGED_NFT',
  104: 'POOLV3_BURN_PARAMETERS_WRONG',
  105: 'POOLV3_RESERVES_PROTECTION_ERROR_SIGN',
  106: 'POOLV3_RESERVES_PROTECTION_ERROR_DRAIN',
  107: 'POOLV3_POOL_MALFORMED',
  110: 'POOL_FACTORY_INVALID_AMOUNT,ROUTERV3_INVALID_AMOUNT',
  111: 'POOL_FACTORY_INVALID_CALLER,ROUTERV3_INVALID_CALLER',
  112: 'POOL_FACTORY_POOL_ILLEGAL_PARAMS,ROUTERV3_POOL_ILLEGAL_PARAMS',
  113: 'POOL_FACTORY_INSUFFICIENT_GAS,ROUTERV3_INSUFFICIENT_GAS',
  114: 'ROUTERV3_TIMELOCK_NOT_RESPECTED',
  200: 'POOLV3_RESULT_SWAP_OK',
  201: 'POOLV3_RESULT_BURN_OK',
  202: 'POOLV3_RESULT_MINT_OK',
  203: 'POOLV3_RESULT_COLLECT_OK',
  220: 'POOLV3_RESULT_TICK_IMPOSSIBLE_LOW',
  221: 'POOLV3_RESULT_TICK_IMPOSSIBLE_HIGH',
  222: 'POOLV3_RESULT_WRONG_TICK_SPACING',
  223: 'POOLV3_RESULT_TOO_MANY_TICKS',
  224: 'POOLV3_RESULT_TOO_MUCH_LIQUIDITY',
  225: 'POOLV3_RESULT_NOT_ENOUGH_COINS',
  226: 'POOLV3_RESULT_NO_LIQUIDITY',
  230: 'POOLV3_RESULT_SWAP_OUTPUT_TOO_SMALL',
  333: 'COMMON_WRONG_WORKCHAIN',
  401: 'NFT_NOT_OWNER,POSITIONNFTV3_NOT_AN_OWNER',
  405: 'POSITIONNFTV3_INIT_NOT_BY_COLLECTION',
  408: 'POSITIONNFTV3_ALREADY_BURNED',
  409: 'POSITIONNFTV3_WRONG_BURN_TICKS',
  705: 'JETTON_NOT_OWNER',
  706: 'JETTON_BALANCE_ERROR',
  707: 'JETTON_NOT_ENOUGH_GAS,JETTON_NOT_VALID_WALLET',
  708: 'POSITIONNFTV3_MESSAGE_TOO_LONG',
  709: 'JETTON_INVALID_OP,JETTON_NOT_ENOUGH_TON',
  65535: 'COMMON_WRONG_OP',
};
